import dayjs from "dayjs";
/**
 * It resets a date by setting hour, minute, second and millisecond to 0.
 */
function resetDate(date) {
  return dayjs(date)?.set("hour", 0).set("minute", 0).set("second", 0).set("millisecond", 0);
}

export default resetDate;
